module.exports = __webpack_public_path__ + "media/images/logo-icon-8c889796bbbd3638693377f82aadd52f.png";